import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getPartyRateList = createAsyncThunk(
    "/quotation/get-party-rate-list",
    async (id) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/${id}/parties`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data?.success === true) {
                return data;
            } else {
                throw new Error(data.message || "Failed to fetch parties data");
            }
        } catch (error) {
            console.error("Comparative API Error:", error);
            const errorMsg = error?.response?.data?.message || error.message || "Error fetching comparative data";
            toast.error(errorMsg);
            throw error; 
        }
    }
);

const initialState = {
    user: null,
    loading: false,
    error: null,
};

const getPartyRateListSlice = createSlice({
    name: "getComparativeView",
    initialState,
    reducers: {
        resetGetPartyRate: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getPartyRateList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPartyRateList.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getPartyRateList.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetPartyRate } = getPartyRateListSlice.actions;

export default getPartyRateListSlice.reducer;
